
// helpers
import scrollTo from './helpers/scrollTo';

// search modules
import searchView from './search/searchView.js';

// modules
import videoLightbox from './modules/mediabox'
import homepageVideo from './modules/homepageVideo.js';
import locations from './modules/locations.js';
import interactiveMap from './modules/map';
import quiz from './modules/quiz';
import blocks from './modules/blocks';
import wall from './modules/wall';
import lazyLoadOnScroll from './modules/lazy';

import mobileMenu from './modules/mobileMenu'
import nav from './modules/navigation'
import columnNav from './modules/columnNav'
import awardCarousel from './modules/awardsCarousel';

mobileMenu({
	menu: '.site-menu-mobile',
	openClass: 'is-open',
	noScrollClass: 'site-menu-mobile-noscroll',
	overlayClass: 'site-menu-mobile-overlay',
	openSelector: '.js-site-menu-mobile--open',
	closeSelector: '.js-site-menu-mobile--close',
	toggleSelector: '.js-site-menu-mobile--toggle'
})

// objectFitImages();
awardCarousel()
nav()
columnNav()

// init jQuery plugins
$.fn.lazyLoadOnScroll = lazyLoadOnScroll;
$.fn.interactiveMap = interactiveMap;
$.fn.quiz = quiz;
$.fn.blocks = blocks;
$.fn.wall = wall;

// init modules / libraries
videoLightbox()
locations.init();
AOS.init();
searchView.init();

// init block elements
$('#map').interactiveMap();
$('#quiz').quiz();

$('.instagram-footer').blocks({
	id: '6038e85e-3df6-409a-a309-241bcb6bcd99'
});

$('.instagram-showcase-wrapper').wall({
	id: '6038e85e-3df6-409a-a309-241bcb6bcd99'
});





// TODO: clean up below into modules



const peopleSlider = (function() {

	const sliderGroupSelector = '.js-people-slider';
	const imageSliderSelector = '.people-image-slider';
	const contentSliderSelector = '.people-content-slider';

	init();

	function init() {
		const $groups = $(sliderGroupSelector);
		$groups.each(function() {
			const $group = $(this);
			const $imageSlider = $group.find(imageSliderSelector);
			const $contentSlider = $group.find(contentSliderSelector);
			setupSliders($imageSlider, $contentSlider);
		});
	}

	function setupSliders($imageSlider, $contentSlider) {

		const $slides = $imageSlider.find('> div');

		const imageSliderOptions = {
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '30%',
			arrows: false,
			// infinite : false,
			asNavFor: $contentSlider,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						centerPadding: '25%',
					}
				},
				{
					breakpoint: 560,
					settings: {
						arrows: false,
						centerPadding: '20%',
					}
				}
			]
		};

		if ($slides.length < 3) {
			imageSliderOptions.infinite = false;
		}

		// setup image slider
		$imageSlider.slick(imageSliderOptions);

		$imageSlider.on('beforeChange', function() {
			$imageSlider.find('.people-active').removeClass('people-active');
		})

		$imageSlider.on('afterChange', function() {
			setTimeout(function() {
				$imageSlider.find('.slick-active, .slick-current').addClass('people-active');
			}, 0);
		})

		// setup content slider
		$contentSlider.slick({
			slidesToShow: 1,
			arrows: false,
			fade:true,
			adaptiveHeight: true,
			asNavFor: '.people-image-slider',
		});
	}

})();




// click slide to go to it
 $('.people-image-slider').on('click', '.slick-slide', function (e) {
	 e.stopPropagation();
    var index = $(this).data("slick-index");
    if ($('.people-image-slider').slick('slickCurrentSlide') !== index) {
      $('.people-image-slider').slick('slickGoTo', index);
    }
});





jQuery(document).ready(function ($) {
	var deviceAgent = navigator.userAgent.toLowerCase();
	if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
		$("html").addClass("ios");
		$("html").addClass("mobile");
	}
	if (navigator.userAgent.search("MSIE") >= 0) {
		$("html").addClass("ie");
	} else if (navigator.userAgent.search("Chrome") >= 0) {
		$("html").addClass("chrome");
	} else if (navigator.userAgent.search("Firefox") >= 0) {
		$("html").addClass("firefox");
	} else if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
		$("html").addClass("safari");
	} else if (navigator.userAgent.search("Opera") >= 0) {
		$("html").addClass("opera");
	}


	$('.day-slider').slick({
	    slidesToShow: 1,
		  //arrows: false,
		  fade:true,
		nextArrow: '<button class="next-button slider-circle-button">next</button>',
			prevArrow: '<button class="prev-button slider-circle-button">prev</button>'
	  });


});


// SCHEMES MODULE


(function() {

	window.onhashchange = onHash;
	onHash();

	let scrollOnHash = true;

	function onHash(e) {

		if (!window.location.hash) return;

		var name = window.location.hash.substr(1),
			$el = $("#" + name);

		if ($el.length) {

			// if it's a legit hash, remove the currently active button and scheme container
			$(".scheme-card.active").removeClass("active");
			$(".scheme-button.active").removeClass("active");

			// add active class to scheme container
			$el.addClass("active")

			// get the button with the matching data-scheme-link, and add the active class to that
			var scheme = $el.data("scheme-link");
			$(".scheme-button[data-scheme-link='" + scheme + "']").addClass("active");

			scrollOnHash && scrollTo($el, 3);

			scrollOnHash = true;
		}
	};

	$('.js-schemes').each(function() {

		const $container = $(this);

		$container.find(".scheme-button").on('click', function(e){

			e.preventDefault();
			var hash = $(this).attr("href");

			scrollOnHash = false;
	    	window.location = hash;

			$container.find(".scheme-button").removeClass("active");

			$(this).addClass("active");

			var link = $(this).data("scheme-link");

			$container.find(".scheme-card").removeClass("active");
			$container.find(".scheme-card[data-scheme-link='" + link + "']").addClass("active");

			return false;
		});
	});


})();







var sizeS;

// media query event handler
if (matchMedia) {
const mq = window.matchMedia("(min-width: 560px)");
mq.addListener(WidthChange);
WidthChange(mq);
}

// media query change
function WidthChange(mq) {
if (mq.matches) {
// window width is at least 768px
	window.sizeS = true;
	//$(".work-button").css("opacity", 1);
} else {
// window width is less than 768px
	window.sizeS = false;

}

}


(function($) {

// AWARDS SLIDER

var awardswrapper = $(".awards-wrapper")[0];

if (awardswrapper){
new FTScroller(awardswrapper, {
			scrollingY: false,
			snapping: false,
			scrollbars: false,
			bouncing:false,
			updateOnWindowResize: true,
			disabledInputMethods: { mouse: false, touch: false, scroll: true, pointer: false, focus: false }
		});

}

var instagramfooter = $(".instagram-footer")[0];

if (instagramfooter){
new FTScroller(instagramfooter, {
			scrollingY: false,
			snapping: false,
			scrollbars: false,
			bouncing:false,
			updateOnWindowResize: true,
			disabledInputMethods: { mouse: false, touch: false, scroll: true, pointer: false, focus: false }
		});

}

 $(".slider-control").click(function() {
            // get data attribute
            var slidenum = $(this).data("slide-goto");

            // get control link ID
            var controlId = $(this).data("control-link");
            // Get the slider with the same control link ID, tell it to go to the defined slide
            $(".cycle-slideshow[data-control-link='" + controlId + "']").cycle('goto', slidenum);
        });


// DESKTOP BENEFITS MODULE

$(".benefit-block").on("click", function(){



if (!$(this).hasClass("expanded")) {



	//animate out the others
	$(".benefit-block.expanded").find(".benefit-description").animate({
	opacity: 'hide',
    height: 'hide',
    paddingTop: 'hide',
    paddingBottom: 'hide'
	}, 300, function() {

		$(this).parent().removeClass("expanded");
		$(this).parent().addClass("contracted");

});


	// animate in this one
  $(this).addClass("expanded").removeClass("contracted").find(".benefit-description").delay(16*10).animate({
    //opacity: 'show',
    height: 'show',
    paddingTop: 'show',
    paddingBottom: 'show'
  },
	{ duration: 300 })
	.animate({ opacity: 1}, 1000 );

}else{

}

});




// ACCORDION


	$(".accordion-trigger").on("click", function(){
		$(this).toggleClass("active");
		$(this).next(".accordion-content").slideToggle(300);

	});




})( jQuery );


setTimeout(() => homepageVideo.init(), 50);